<template>
    <a-modal
            :title='titles'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @cancel="onClose"
    >
        <div class="seachList"><span class="name" v-if="importType==4">分类选择：</span>
            <a-select style="margin-right: 20px" v-model="classId" class="seachs" allowClear :placeholder="'请选择'" v-if="importType==4">
                <a-select-option :value="item.id" :key="index" v-for="(item,index) in classList">
                    {{item.name}}
                </a-select-option>
            </a-select>
            <span class="name" >导入类型：</span>
            <a-select v-model="type" class="seachs" allowClear :placeholder="'请选择'">
                <a-select-option :value="item.id" :key="index" v-for="(item,index) in importTypeList">
                    {{item.name}}
                </a-select-option>
            </a-select>
        </div>
        <div class="seachList">
        </div>
        <a-upload-dragger
                name="file"
                :beforeUpload="handleBeforeUpload"
                :remove="removeChange"
                :fileList="fileList"
                @drop="handleDrop"
        >
            <p class="ant-upload-drag-icon">
                <a-icon style="color: #0260F8" type="cloud-upload" />
            </p>
            <p class="">将文件拖拽到此区域，或 <span style="color: #0260F8">点击添加</span></p>
        </a-upload-dragger>
        <div class="tip">
            <div class="left">
                友情提示：
            </div>
            <div class="right">
                <div v-if="importType==5||importType==4">
                    <p>1、导入的文档格式必须为“zip”或“rar”格式，其余格式暂不支持导入;</p>
                    <p>2、导入的文档大小不超过100M，超出后会导致失败；</p>
                </div>
                <div v-else>
                    <p>1、导入的文档格式必须为“xls”或“xlsx”格式，其余格式暂不支持导入;</p>
                    <p>2、导入的文档大小不超过2M，超出后会导致失败；</p>
                </div>
                <p v-if="importType!=5">3、文档格式模版， <span style="color: #0260f8;cursor:pointer" @click="downLoad">点击下载；</span> </p>
            </div>
        </div>
        <template #footer >
                <a-button key="back" @click="onSubmit" type="primary">确定</a-button>
                <a-button key="submit"   @click="onClose">取消</a-button>
        </template>
    </a-modal>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import { MessageOutlined } from '@ant-design/icons-vue';
    import API from "../api";
    import axiosUpload from 'axios';
    import axios from 'axios';
    export default {
        components:{MessageOutlined},
        props: ["visible","importType","dataList","product_ids"],
        name: "importModel",
        data(){
            return {
                drawerConfig,
                titles:'',
                type:1,
                fileList:[],
                classId:'',
                classList:[],
                importTypeList:[],
            }
        },
        mounted(){
            console.log(this.importType,'importType')
            console.log(this.dataList,'dataList')
            if(this.importType == 5||this.importType == 3){
                this.importTypeList.push(this.dataList.methods[0])
                // this.dataList.methods.splice(1,1)
                console.log(this.dataList.methods)
                // this.dataList.methods = this.dataList.methods
            }else{
                this.importTypeList = this.dataList.methods
            }
            this.dataList.types.forEach((item,index)=>{
                if(item.id==this.importType){
                    this.titles = `导入${item.name}`
                }
            })
            if(this.importType == 4){
                let data = {
                    id:this.product_ids
                }
                API.service.GET_CLASS(data).then(res=>{
                    console.log(res)
                    this.classList = res.data.data
                })
            }
        },
        methods:{
            removeChange(){
                this.fileList = []
            },

            handleBeforeUpload(file) {
                // 在这里保存文件到 fileList，但不开始上传
                if(this.fileList.length>0){
                }else{
                    this.fileList.push(file);
                }
                return false; // 返回 false 以阻止自动上传
            },
            onClose(){
                this.type = 1
                this.fileList = []
                this.$emit("changVisible", false);
                },
            downLoad(){
                console.log(this.$store.state)
                let data = {
                    type:this.importType
                }
                API.service.GET_LOAD(data).then(res=>{
                    window.open(res.data.data.file)
                })
            },
            onSubmit(){
                let data = new FormData()
                data.append('id',this.product_ids)
                data.append('type',this.importType)
                data.append('method',this.type)
                if(this.importType==4){
                data.append('cate_id',this.classId)
                }
                data.append('file',this.fileList[0])
                axios.post(this.$store.state.urlRequest+'/batch/fileLib/import', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization:  window.sessionStorage.getItem('signature'),
                    }
                }).then(res => {
                    // 处理上传成功的响应
                    console.log(res.data)
                    if(res.data.code==200){
                        this.$message.success(res.data.msg);
                        this.type = 1
                        this.fileList = []
                        this.$emit("changVisible", false);
                    }else{
                        this.$message.warning(res.data.msg);
                    }
                })
            },
        },
        watch:{
            importType:function(a,b){
    },
        }
    }
</script>

<style scoped>
     .seachs {
        width: 160px;
    }
    .seachList{
        margin-bottom: 20px;
    }
    .tip{
        display: flex;
        margin-top: 20px;
    }
</style>